module.exports = __webpack_public_path__ + "img/Welcome03.36987692.svg";